// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"about_wrapper__2z39h","aboutHead":"about_aboutHead__2csST"};